import React from 'react';


function WhiteLayout(props) {
	return (
		<div className="hold-transition empty-page">
		
                {props.children}
        
		</div>
	);
}

export default WhiteLayout;
